// extracted by mini-css-extract-plugin
export var dropdown = "_mg-1";
export var hidden = "_mg-0";